import { atom, useSetRecoilState, useRecoilValue, selector } from 'recoil';
import { DebitNote } from '../pages/customer-debit-notes/interface/DebiitNote.Interface';

// Types
interface StatusInfo {
  // Add your status info properties here
  [key: string]: any;
}

export interface DebitNoteState {
  debit_note: DebitNote[];
  status_info: StatusInfo[];
}

interface CreditNoteEdit {
  // Add your credit note properties here
  [key: string]: any;
}


// Atoms
export const debitNoteAtom = atom<DebitNoteState>({
  key: 'debit_note_atom',
  default: { debit_note: [], status_info: [] },
});

export const debitNotEditAtom = atom<CreditNoteEdit>({
  key: 'debit_note_edit_atom',
  default: {},
});

// Hooks
export const SetDebitNoteListAtom = () => useSetRecoilState(debitNoteAtom);
export const GetDebitNoteListAtom = () => useRecoilValue(debitNoteAtom);

export const SetEditDebitNoteAtom = () => useSetRecoilState(debitNotEditAtom);
export const GetEditDebitNoteAtom = () => useRecoilValue(debitNotEditAtom);
